module.exports = "assets/img/m-0.png";